import { __extends } from "tslib";
import PropType from './prop-type.class';
var Integer = /*@__PURE__*/ (function (_super) {
    __extends(Integer, _super);
    function Integer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Integer.validate = function (value) {
        return /^\d+$/.test(value);
    };
    Integer.parseValue = function (value) {
        return parseInt(value, 10);
    };
    return Integer;
}(PropType));
export default Integer;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/shop-builder/core/prop-types/integer.ts
// module id = null
// module chunks = 